import { fillChapterOfLevel } from "./chapters.ts";
import { FILL_CONTENT_VERSION, FILL_PACK_LOADERS } from "./packs.generated.ts";
import { fillPackSchema, type FillLevel, type FillPack } from "./schema.ts";

const packCache = new Map<number, Promise<FillPack>>();

/** Loads (once) and validates one Magic Workshop chapter pack; nothing of the house downloads before. */
export function loadFillChapter(chapter: number): Promise<FillPack> {
  let pending = packCache.get(chapter);
  if (!pending) {
    const loader = FILL_PACK_LOADERS[chapter];
    if (!loader) return Promise.reject(new Error(`no fill pack for chapter ${chapter}`));
    pending = loader().then((raw) => {
      const pack = fillPackSchema.parse(raw);
      if (pack.contentVersion !== FILL_CONTENT_VERSION) throw new Error(`pack ${chapter} has version ${pack.contentVersion}`);
      return pack;
    });
    pending.catch(() => packCache.delete(chapter));
    packCache.set(chapter, pending);
  }
  return pending;
}

export async function loadFillLevel(levelId: number): Promise<FillLevel> {
  const pack = await loadFillChapter(fillChapterOfLevel(levelId).chapter);
  const level = pack.levels.find((candidate) => candidate.id === levelId);
  if (!level) throw new Error(`fill level ${levelId} missing from pack`);
  return level;
}
